function formatAmount(amount) {
  if (typeof amount !== 'number') {
    return amount; // Return as-is if not a number
  }

  const sign = amount < 0 ? '-' : '';
  const absAmount = Math.abs(amount);

  if (absAmount >= 1000000000000) { // Trilion
    return sign + (absAmount / 1000000000000).toFixed(1) + ' T';
  } else if (absAmount >= 1000000000) { // Billion
    return sign + (absAmount / 1000000000).toFixed(1) + ' B';
  } else if (absAmount >= 1000000) { // Million
    return sign + (absAmount / 1000000).toFixed(1) + ' M';
  } else {
    return sign + absAmount.toFixed(1); // Return as-is if less than 1 million
  }
}

function formatCurrency(currency_country){
  if (currency_country === 'USA') {
    return ' $';
  } else {
    return ''
  }
}

function formatDate(dateString, input_format, output_format){
  if(input_format === "yyyy-MM-dd" && output_format === "q_yyyy"){
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-indexed (0 = January, 11 = December)
    const quarter = Math.floor(month / 3) + 1; // Calculate quarter
  
    return `Q${quarter} ${year}`;
  }
}

/* export const axisTickFormatter = (item, value) => {//Y Axis
  //console.log(value);
  if(item?.metadata){
    if(JSON.parse(item.metadata)[item.y_cord]?.type === "currency"){
      return `${formatAmount(value)} ${formatCurrency(JSON.parse(item.metadata)[item.y_cord]?.meta_attribute?.currency_country)}`;
    } else if(JSON.parse(item.metadata)[item.y_cord]?.type === "percent"){
      return `${value}%`;
    } else if(JSON.parse(item.metadata)[item.y_cord]?.type === "Date"){
      return `${formatDate(value, JSON.parse(item.metadata)[item.y_cord]?.meta_attribute?.input_format, JSON.parse(item.metadata)[item.y_cord]?.meta_attribute?.output_format)}`;
    } else {
      return `${value}`;
    }
  } else {
    return `${value}`;
  }
}; */

export const axisTickFormatter = (item, value, cord) => {
  if(item?.metadata){
    if (!item || !item.data || !Array.isArray(item.data) || !JSON.parse(item.metadata) || typeof JSON.parse(item.metadata) !== 'object') {
      return "Invalid JSON format";
    }

    const details = item.data;
    const metadata = JSON.parse(item.metadata);
    let result = `${value}`;

    if (details.length > 0) {
      // Get keys from the first object in details array, assuming all details objects have same keys.
      const keys = Object.keys(details[0]);

      keys.forEach(key => {
        if(metadata[key] !== undefined){
          //console.log(metadata[key]);
          //console.log(metadata[key].type);
          if(metadata[key].type === "currency" && key === cord){
            result = `${formatAmount(value)} ${formatCurrency(metadata[key].meta_attribute?.currency_country)}`;
          } else if(metadata[key].type === "percent" && key === cord){
            result = `${value}%`;
          } else if(metadata[key].type === "Date" && key === cord){
            result = `${formatDate(value, metadata[key].meta_attribute?.input_format, metadata[key].meta_attribute?.output_format)}`;
          }
        }
      });
      return result;
    } else {
      return `${value}`;
    }
  } else {
    return `${value}`;
  }
}

export const formatterFunction = (item, value, name, entry) => {//Tooltip
  if(item?.metadata){
    if (!item || !item.data || !Array.isArray(item.data) || !JSON.parse(item.metadata) || typeof JSON.parse(item.metadata) !== 'object') {
      return "Invalid JSON format";
    }

    const details = item.data;
    const metadata = JSON.parse(item.metadata);
    let result = [value, name];

    if (details.length > 0) {
      // Get keys from the first object in details array, assuming all details objects have same keys.
      const keys = Object.keys(details[0]);
      //console.log(keys);

      keys.forEach(key => {
        if(metadata[key] !== undefined){
          //console.log(metadata[key]);
          //console.log(metadata[key].type);
          if(metadata[key].type === "currency"){
            result = [`${formatAmount(value)} ${formatCurrency(JSON.parse(item.metadata)[item.y_cord]?.meta_attribute?.currency_country)}`, name];
          } else if(metadata[key].type === "percent"){
            result = [`${value}%`, name];
          } else if(metadata[key].type === "Date"){
            result = [`${formatDate(value, JSON.parse(item.metadata)[item.y_cord]?.meta_attribute?.input_format, JSON.parse(item.metadata)[item.y_cord]?.meta_attribute?.output_format)}`, name];
          }
        }
      });
      return result;
    } else {
      return [value, name];
    }
    /* if(JSON.parse(item.metadata)[item.y_cord]?.type === "currency"){
      return [`${formatAmount(value)} ${formatCurrency(JSON.parse(item.metadata)[item.y_cord]?.meta_attribute?.currency_country)}`, name];
    } else if(JSON.parse(item.metadata)[item.y_cord]?.type === "percent"){
      return [`${value}%`, name];
    } else if(JSON.parse(item.metadata)[item.y_cord]?.type === "Date"){
      return [`${formatDate(value, JSON.parse(item.metadata)[item.y_cord]?.meta_attribute?.input_format, JSON.parse(item.metadata)[item.y_cord]?.meta_attribute?.output_format)}`, name];
    } else {
      return [value, name];
    } */
  } else {
    return [value, name];
  }
};